<template>
  <div>
    <!--기본정보-->
    <field-select-module
      v-model="form.stdInfo"
      :options="[
        { type: 'date', label: '점검일' },
        { type: 'text', label: '점검장소' },
        { type: 'disaster', label: '재해형태' },
        { type: 'file', label: '필수 첨부서류', value: 'file', labelStyle: 'color:#EA5455' },
      ]"
      :board="this.board"
      :is-print="isPrint"
    />

    <!--    작업 목록-->
    <vs-row class="mt-6">
      <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
        <h5><i class="dot"></i> 작업구분</h5>
      </vs-col>
    </vs-row>

    <div class="grid grid-cols-12 gap-x-6 gap-y-4 mt-4">
      <div class="col-span-3 flex items-center" v-for="checkbox in form.inspectionList" v-bind:key="checkbox.id">
        <div v-if="isPrint || board.readonly" class="flex">
          <div v-if="checkbox.check" style="background: #200c63" class="w-5 h-5 rounded-sm text-white flex justify-center items-center mr-2">
            <vs-icon icon="check" size="x-small"></vs-icon>
          </div>
          <div v-else style="border: 1px solid #200c63" class="w-5 h-5 rounded-sm text-white flex justify-center items-center mr-2">
            <vs-icon icon="check" size="x-small"></vs-icon>
          </div>
          {{ checkbox.label }}
        </div>
        <label v-else class="flex">
          <vs-checkbox :readonly="board.readonly" v-model="checkbox.check" @change="checkForm"> </vs-checkbox>
          {{ checkbox.label }}
        </label>
      </div>
    </div>

    <!--    장비 정보-->
    <vs-row class="mt-6">
      <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
        <h5><i class="dot"></i> 장비 정보</h5>
      </vs-col>
    </vs-row>
    <div class="grid grid-cols-12 gap-x-6 gap-y-4 mt-4">
      <div class="col-span-4 flex items-center">
        <div class="label-text mr-4">장비 업체명</div>
        <p v-if="isPrint" class="print-input">{{ form.inputB_1 }}</p>
        <ml-input v-else :readonly="board.readonly" v-model="form.inputB_1" class="w-full flex-1" />
      </div>
      <div class="col-span-4 flex items-center">
        <div class="label-text mr-4">장비 운전원</div>
        <p v-if="isPrint" class="print-input">{{ form.inputB_2 }}</p>
        <ml-input v-else :readonly="board.readonly" v-model="form.inputB_2" class="w-full flex-1" />
      </div>
      <!--      <div class="col-span-4 flex items-center">-->
      <!--        <div class="label-text mr-4">운전원 면허번호</div>-->
      <!--        <p v-if="isPrint" class="print-input">{{ form.inputB_3 }}</p>-->
      <!--        <ml-input-->
      <!--          v-else-->
      <!--          :readonly="board.readonly"-->
      <!--          v-model="form.inputB_3"-->
      <!--          class="w-full flex-1"-->
      <!--        />-->
      <!--      </div>-->

      <div class="col-span-4 flex items-center">
        <div class="label-text mr-4">장비 종류(기종 및 모델명)</div>
        <p v-if="isPrint" class="print-input">{{ form.inputB_4 }}</p>
        <ml-input v-else :readonly="board.readonly" v-model="form.inputB_4" class="w-full flex-1" />
      </div>
      <div class="col-span-4 flex items-center">
        <div class="label-text mr-4">장비 형식 및 규격(정격하종)</div>
        <p v-if="isPrint" class="print-input">{{ form.inputB_5 }}</p>
        <ml-input v-else :readonly="board.readonly" v-model="form.inputB_5" class="w-full flex-1" />
      </div>
      <!--      <div class="col-span-4 flex items-center">-->
      <!--        <div class="label-text mr-4">장비 지지방법 및 기타</div>-->
      <!--        <p v-if="isPrint" class="print-input">{{ form.inputB_6 }}</p>-->
      <!--        <ml-input-->
      <!--          v-else-->
      <!--          :readonly="board.readonly"-->
      <!--          v-model="form.inputB_6"-->
      <!--          class="w-full flex-1"-->
      <!--        />-->
      <!--      </div>-->
      <div class="col-span-4 flex items-center">
        <div class="label-text mr-4">작업지휘자</div>
        <p v-if="isPrint" class="print-input">{{ form.inputB_7 }}</p>
        <ml-input v-else :readonly="board.readonly" v-model="form.inputB_7" class="w-full flex-1" />
      </div>
      <div class="col-span-4 flex items-center">
        <div class="label-text mr-4">작업유도자</div>
        <p v-if="isPrint" class="print-input">{{ form.inputB_8 }}</p>
        <ml-input v-else :readonly="board.readonly" v-model="form.inputB_8" class="w-full flex-1" />
      </div>
    </div>

    <!--    현장개요-->
    <!--    <vs-row class="mt-6">-->
    <!--      <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">-->
    <!--        <h5>-->
    <!--          <i class="dot"></i> 현장개요-->
    <!--        </h5>-->
    <!--      </vs-col>-->
    <!--    </vs-row>-->
    <!--    <div class="grid grid-cols-12 gap-x-6 gap-y-4 mt-4">-->
    <!--      <div class="col-span-4 flex items-center">-->
    <!--        <div class="label-text mr-4">현장주소</div>-->
    <!--        <p v-if="isPrint" class="print-input">{{ form.inputC_1 }}</p>-->
    <!--        <company-selector-->
    <!--          v-else-->
    <!--          :readonly="board.readonly"-->
    <!--          v-model="form.inputC_1"-->
    <!--          class="w-full flex-1"-->
    <!--        />-->
    <!--      </div>-->
    <!--      <div class="col-span-4 flex items-center">-->
    <!--        <div class="label-text mr-4">공사금액</div>-->
    <!--        <p v-if="isPrint" class="print-input">{{ form.inputC_2 }}</p>-->
    <!--        <ml-input-->
    <!--          v-else-->
    <!--          :readonly="board.readonly"-->
    <!--          class="w-full flex-1"-->
    <!--          placeholder=""-->
    <!--          v-model="form.inputC_2"/>-->
    <!--      </div>-->
    <!--      <div class="col-span-4 flex items-center">-->
    <!--        <div class="label-text mr-4">공사기간</div>-->
    <!--        <p v-if="isPrint" class="print-input">-->
    <!--          {{ form.inputC_3 }} ~ {{ form.inputC_4 }}-->
    <!--        </p>-->
    <!--        <div v-else class="flex-1 flex items-center">-->
    <!--          <date-selector-->
    <!--            class="w-full flex-1"-->
    <!--            v-model="form.inputC_3"-->
    <!--            :readonly="board.readonly"-->
    <!--          />-->
    <!--          <p class="px-2">~</p>-->
    <!--          <date-selector-->
    <!--            class="w-full flex-1"-->
    <!--            v-model="form.inputC_4"-->
    <!--            :readonly="board.readonly"-->
    <!--          />-->
    <!--        </div>-->
    <!--      </div>-->

    <!--      <div class="col-span-4 flex items-center">-->
    <!--        <div class="label-text mr-4">공종명</div>-->
    <!--        <p v-if="isPrint" class="print-input">{{ form.inputC_5 }}</p>-->
    <!--        <ml-input-->
    <!--          v-else-->
    <!--          :readonly="board.readonly"-->
    <!--          v-model="form.inputC_5"-->
    <!--          class="w-full flex-1"-->
    <!--        />-->
    <!--      </div>-->
    <!--      <div class="col-span-4 flex items-center">-->
    <!--        <div class="label-text mr-4">작업장소</div>-->
    <!--        <p v-if="isPrint" class="print-input">{{ form.inputC_6 }}</p>-->
    <!--        <ml-input-->
    <!--          v-else-->
    <!--          :readonly="board.readonly"-->
    <!--          v-model="form.inputC_6"-->
    <!--          class="w-full flex-1"-->
    <!--        />-->
    <!--      </div>-->
    <!--      <div class="col-span-4 flex items-center">-->
    <!--        <div class="label-text mr-4">작업기간</div>-->
    <!--        <p v-if="isPrint" class="print-input">-->
    <!--          {{ form.inputC_7 }} ~ {{ form.inputC_8 }}-->
    <!--        </p>-->
    <!--        <div v-else class="flex-1 flex items-center">-->
    <!--          <date-selector-->
    <!--            class="w-full flex-1"-->
    <!--            v-model="form.inputC_7"-->
    <!--            :readonly="board.readonly"-->
    <!--          />-->
    <!--          <p class="px-2">~</p>-->
    <!--          <date-selector-->
    <!--            class="w-full flex-1"-->
    <!--            v-model="form.inputC_8"-->
    <!--            :readonly="board.readonly"-->
    <!--          />-->
    <!--        </div>-->
    <!--      </div>-->

    <!--      <div class="col-span-4 flex items-start mt-4">-->
    <!--        <div class="label-text mr-4 mt-2">-->
    <!--          상세 작업내용-->
    <!--        </div>-->
    <!--        <p v-if="isPrint" class="print-textarea">{{ form.inputC_9 }}</p>-->
    <!--        <ml-textarea-->
    <!--          :readonly="board.readonly"-->
    <!--          v-else-->
    <!--          v-model="form.inputC_9"-->
    <!--          class="flex-1 w-full"-->
    <!--          rows="5"-->
    <!--        />-->
    <!--      </div>-->
    <!--      <div class="col-span-4 flex items-start mt-4">-->
    <!--        <div class="label-text mr-4 mt-2">-->
    <!--          작업순서-->
    <!--        </div>-->
    <!--        <p v-if="isPrint" class="print-textarea">{{ form.inputC_10 }}</p>-->
    <!--        <ml-textarea-->
    <!--          :readonly="board.readonly"-->
    <!--          v-else-->
    <!--          v-model="form.inputC_10"-->
    <!--          class="flex-1 w-full"-->
    <!--          rows="5"-->
    <!--        />-->
    <!--      </div>-->
    <!--      <div class="col-span-4 flex items-start mt-4">-->
    <!--        <div class="label-text mr-4 mt-2">-->
    <!--          지장물 현황-->
    <!--        </div>-->
    <!--        <p v-if="isPrint" class="print-textarea">{{ form.inputC_11 }}</p>-->
    <!--        <ml-textarea-->
    <!--          :readonly="board.readonly"-->
    <!--          v-else-->
    <!--          v-model="form.inputC_11"-->
    <!--          class="flex-1 w-full"-->
    <!--          rows="5"-->
    <!--        />-->
    <!--      </div>-->
    <!--      <div class="col-span-4 flex items-start mt-4">-->
    <!--        <div class="label-text mr-4 mt-2">-->
    <!--          인원투입계획-->
    <!--        </div>-->
    <!--        <p v-if="isPrint" class="print-textarea">{{ form.inputC_12 }}</p>-->
    <!--        <ml-textarea-->
    <!--          :readonly="board.readonly"-->
    <!--          v-else-->
    <!--          v-model="form.inputC_12"-->
    <!--          class="flex-1 w-full"-->
    <!--          rows="5"-->
    <!--        />-->
    <!--      </div>-->
    <!--      <div class="col-span-4 flex items-start mt-4">-->
    <!--        <div class="label-text mr-4 mt-2">-->
    <!--          자재투입계획-->
    <!--        </div>-->
    <!--        <p v-if="isPrint" class="print-textarea">{{ form.inputC_13 }}</p>-->
    <!--        <ml-textarea-->
    <!--          :readonly="board.readonly"-->
    <!--          v-else-->
    <!--          v-model="form.inputC_13"-->
    <!--          class="flex-1 w-full"-->
    <!--          rows="5"-->
    <!--        />-->
    <!--      </div>-->
    <!--      <div class="col-span-4 flex items-start mt-4">-->
    <!--        <div class="label-text mr-4 mt-2">-->
    <!--          장비투입계획-->
    <!--        </div>-->
    <!--        <p v-if="isPrint" class="print-textarea">{{ form.inputC_14 }}</p>-->
    <!--        <ml-textarea-->
    <!--          :readonly="board.readonly"-->
    <!--          v-else-->
    <!--          v-model="form.inputC_14"-->
    <!--          class="flex-1 w-full"-->
    <!--          rows="5"-->
    <!--        />-->
    <!--      </div>-->
    <!--      <div class="col-span-4 flex items-start mt-4">-->
    <!--        <div class="label-text mr-4 mt-2">-->
    <!--          유해·위험요인 및 재해형태-->
    <!--        </div>-->
    <!--        <p v-if="isPrint" class="print-textarea">{{ form.inputC_15 }}</p>-->
    <!--        <ml-textarea-->
    <!--          :readonly="board.readonly"-->
    <!--          v-else-->
    <!--          v-model="form.inputC_15"-->
    <!--          class="flex-1 w-full"-->
    <!--          rows="5"-->
    <!--        />-->
    <!--      </div>-->
    <!--      <div class="col-span-4 flex items-start mt-4">-->
    <!--        <div class="label-text mr-4 mt-2">-->
    <!--          안전대책-->
    <!--        </div>-->
    <!--        <p v-if="isPrint" class="print-textarea">{{ form.inputC_16 }}</p>-->
    <!--        <ml-textarea-->
    <!--          :readonly="board.readonly"-->
    <!--          v-else-->
    <!--          v-model="form.inputC_16"-->
    <!--          class="flex-1 w-full"-->
    <!--          rows="5"-->
    <!--        />-->
    <!--      </div>-->
    <!--      <div class="col-span-4 flex items-start mt-4">-->
    <!--        <div class="label-text mr-4 mt-2">-->
    <!--          사고 시 비상 대응체계-->
    <!--        </div>-->
    <!--        <p v-if="isPrint" class="print-textarea">{{ form.inputC_17 }}</p>-->
    <!--        <ml-textarea-->
    <!--          :readonly="board.readonly"-->
    <!--          v-else-->
    <!--          v-model="form.inputC_17"-->
    <!--          class="flex-1 w-full"-->
    <!--          rows="5"-->
    <!--        />-->
    <!--      </div>-->
    <!--      <div class="col-span-4 flex items-center">-->
    <!--        <div class="label-text mr-4">작업 계획도 및 관련 도면 첨부</div>-->
    <!--        <p v-if="isPrint" class="print-input">-->
    <!--          {{ form.inputC_18.fileName }}-->
    <!--        </p>-->
    <!--        <file-uploader-->
    <!--          :readonly="board.readonly"-->
    <!--          v-else-->
    <!--          v-model="form.inputC_18"-->
    <!--          class="w-full flex-1"-->
    <!--        />-->
    <!--      </div>-->
    <!--    </div>-->

    <div v-for="(inspection, indexRows) in form.inspectionList" v-bind:key="inspection.id">
      <!--    목록표 -->
      <table-inspect-division
        class="mt-2"
        v-bind:key="inspection.id"
        :is-print="isPrint"
        :is-readonly="board.readonly"
        :is-show-title="true"
        :title="inspection.title"
        :list="inspection.list"
        @update-list-check="
          (param1, param2, param3) => {
            updateListCheck(indexRows, param1, param2, param3);
          }
        "
        v-if="inspection.check"
      />

      <table-duration
        :title="'관리자 및 작업자명단'"
        :col-title_1="'구분'"
        :col-title_2="'성명'"
        :col-title_3="'참여기간'"
        :col-title_4="'직종'"
        :list="form.adminList"
        :isPrint="isPrint"
        :isReadonly="board.readonly"
        @updateList="updateList"
        v-if="inspection.check && indexRows === 1"
      />
    </div>

    <!-- 확인자 -->
    <div>
      <div class="mt-4">
        <h5><i class="dot"></i> 확인자</h5>
      </div>
      <div class="writeGridContainer" style="align-items: center">
        <div>
          <div>안전관리자</div>
          <ml-input v-if="!isPrint" v-model="form.sign1.name" :readonly="board.readonly" />
          <span v-else class="print-input">{{ form.sign1.name }}</span>
        </div>
        <div style="align-items: center">
          <div class="pt-2">서명</div>
          <sign-field v-if="!isPrint && !board.readonly" v-model="form.sign1.sign" class="w-full flex-1 p-1" />
          <div v-else class="w-full flex-1 p-1">
            <img v-if="form.sign1.sign" :src="form.sign1.sign" width="100%" alt="Signature" class="signatureImg" />
            <div v-else class="signatureImg"></div>
          </div>
        </div>
      </div>
      <div class="writeGridContainer" style="align-items: center">
        <div>
          <div>관리책임자</div>
          <ml-input v-if="!isPrint" v-model="form.sign2.name" :readonly="board.readonly" />
          <span v-else class="print-input">{{ form.sign2.name }}</span>
        </div>
        <div style="align-items: center">
          <div class="pt-2">서명</div>
          <sign-field v-if="!isPrint && !board.readonly" v-model="form.sign2.sign" class="w-full flex-1 p-1" />
          <div v-else class="w-full flex-1 p-1">
            <img v-if="form.sign2.sign" :src="form.sign2.sign" width="100%" alt="Signature" class="signatureImg" />
            <div v-else class="signatureImg"></div>
          </div>
        </div>
      </div>
    </div>

    <!-- 파일첨부 -->
    <file-upload-module id="fileList" class="w-full mt-4" v-model="form.fileList" :is-print="isPrint" :readonly="board.readonly" title="작업 계획도 및 관련 도면 첨부"></file-upload-module>
  </div>
</template>

<script>
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import PopupPlanProject from "@/views/project/popup/PopupPlanProject";
import DateSelector from "@/components/selector/DateSelector";
import PopupProjectSetting from "@/views/project/PopupProjectSetting";
import MemberSelector from "@/components/selector/MemberSelector";
import CompanySelector from "@/components/selector/CompanySelector";
import FileUploader from "@/components/FileUploader";
import FileUploadModule from "@/views/modules/FileUploadModule";
import TableInspect from "@/components/TableInspect";
import TableInspectDivision from "@/components/TableInspectDivision";
import TableDuration from "../../../../components/TableDuration";
import SignField from "@/components/SignField.vue";
import { required } from "vuelidate/lib/validators";

export default {
  components: {
    SignField,
    TableDuration,
    TableInspectDivision,
    TableInspect,
    FieldSelectModule,
    FileUploadModule,
    FileUploader,
    CompanySelector,
    MemberSelector,
    PopupProjectSetting,
    DateSelector,
    PopupPlanProject,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  validations: {
    form: {
      stdInfo: {
        file: { required },
      },
    },
  },
  watch: {
    value: {
      important: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }

        if (!this.form || !this.form.inspectionList || this.form.inspectionList.length === 0) {
          this.form.inspectionList = this.inspectionList;
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
  },
  methods: {
    checkForm() {
      this.form.typeTitleList = [];
      for (const data of this.form.inspectionList) {
        if (data.check) {
          this.form.typeTitleList.push(data.label);
        }
      }
    },
    updateListCheck(indexList, indexTableRows, indexRows, text) {
      this.form.inspectionList[indexList].list[indexTableRows].list[indexRows].is_checked = text;
    },
    updateList(list) {
      this.form.adminList = list;
    },

    validate() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        if (!this.$v.form.stdInfo.file.required) return "필수 첨부서류를 첨부해주세요.";
      }
    },
  },
  computed: {
    getInspectionListTitle() {
      let result = "";
      for (const data of this.form.inspectionList) {
        if (data.check) {
          result += `${data.label} , `;
        }
      }

      if (result.length > 0) {
        result = result.substring(0, result.length - 2);
      }
      return result;
    },
    inspectionList() {
      return [
        {
          id: 1,
          label: "유지·보수 작업",
          check: false,
          title: "사전조사 및 작업계획서 내용(산업안전보건기준에 관한 규칙 [별표4], 제38조 제1항관련)",
          list: [
            {
              headerTitle: "작업계획서 내용",
              headerYesTitle: "작성",
              headerNoTitle: "미작성",
              isTypeMode: false,
              isInputMode: false,
              list: [
                {
                  id: 1,
                  type: "가",
                  label: "개인보호구는 반드시 착용할 것(예시: 방독, 휴대용산소, 보안경 등)",
                  is_checked: "",
                },
                {
                  id: 2,
                  type: "나",
                  label: "작업 종료 후 작업구간 안전점검 철저",
                  is_checked: "",
                },
                {
                  id: 3,
                  type: "다",
                  label: "작업순서를 준수하여 관리감독 하에 작업",
                  is_checked: "",
                },
              ],
            },
          ],
        },
        {
          id: 2,
          label: "주말·휴일작업",
          check: false,
          title: "위험작업내용",
          list: [
            {
              headerTitle: "위험작업",
              headerYesTitle: "작성",
              headerNoTitle: "미작성",
              isTypeMode: true,
              isInputMode: false,
              list: [
                {
                  id: 1,
                  type: "가",
                  label: "타워크레인을 설치·조립·해체·상승작업",
                  is_checked: "",
                },
                {
                  id: 2,
                  type: "나",
                  label: "콘크리트 타설·양생작업",
                  is_checked: "",
                },
                {
                  id: 3,
                  type: "다",
                  label: "이동식 크레인 및 고소작업대 사용작업",
                  is_checked: "",
                },
                {
                  id: 4,
                  type: "라",
                  label: "외부비계 설치·해체작업",
                  is_checked: "",
                },
                {
                  id: 5,
                  type: "마",
                  label: "거푸집 설치·해체작업",
                  is_checked: "",
                },
              ],
            },
            {
              headerTitle: "사고 시 비상대응체계",
              headerYesTitle: "작성",
              headerNoTitle: "미작성",
              isTypeMode: true,
              isInputMode: true,
              list: [
                {
                  id: 1,
                  type: "가",
                  label: "원청 :",
                  is_checked: "",
                  labelContent: "",
                },
                {
                  id: 2,
                  type: "나",
                  label: "작업업체 :",
                  is_checked: "",
                  labelContent: "",
                },
                {
                  id: 3,
                  type: "다",
                  label: "감리단 :",
                  is_checked: "",
                  labelContent: "",
                },
                {
                  id: 4,
                  type: "라",
                  label: "병원 :",
                  is_checked: "",
                  labelContent: "",
                },
                {
                  id: 5,
                  type: "마",
                  label: "고용부 :",
                  is_checked: "",
                  labelContent: "",
                },
                {
                  id: 6,
                  type: "바",
                  label: "경찰 :",
                  is_checked: "",
                  labelContent: "",
                },
              ],
            },
          ],
        },
        {
          id: 3,
          label: "기타작업(야간작업)",
          check: false,
          title: "사전조사 및 작업계획서 내용(산업안전보건기준에 관한 규칙 [별표4], 제38조 제1항관련)",
          list: [
            {
              headerTitle: "작업환경 요인",
              headerYesTitle: "작성",
              headerNoTitle: "미작성",
              isTypeMode: true,
              isInputMode: false,
              list: [
                {
                  id: 1,
                  type: "가",
                  label: "조도 관리는 노동자의 연령과 작업특성을 고려하여 작업장 조명의 밝기(2,500 ~ 9,500lux)는 유지되는가?",
                  is_checked: "",
                },
                {
                  id: 2,
                  type: "나",
                  label: "온도 조절은 야간작업 시 작업장의 온도를 적절한 수준(27℃가 넘지 않는 범위에서 주간작업 때보다 약 1℃정도 높임)으로 유지되는가?",
                  is_checked: "",
                },
                {
                  id: 3,
                  type: "다",
                  label: "편의시설 제공 및 응급처치 설비, 이송 등의 치료체계 확보 여부?",
                  is_checked: "",
                },
              ],
            },
            {
              headerTitle: "작업조건 요인",
              headerYesTitle: "작성",
              headerNoTitle: "미작성",
              isTypeMode: true,
              isInputMode: false,
              list: [
                {
                  id: 1,
                  type: "가",
                  label: "야간반 교대시간은 가급적 자정 이전으로 해야하고 연속 3일 이상의 야간작업은 자제하는가?",
                  is_checked: "",
                },
                {
                  id: 2,
                  type: "나",
                  label: "교대작업 방법은 아침반 > 저녁반 > 야간반 > 아침반 등의 순으로 교대방향을 유지하고 있는가?",
                  is_checked: "",
                },
                {
                  id: 3,
                  type: "다",
                  label: "야간반 근무를 마친 후 아침반 근무에 들어가기 전 최소한 24시간 이상 휴식을 취하고 있는가?",
                  is_checked: "",
                },
                {
                  id: 4,
                  type: "라",
                  label: "갑자기 주어지는 야근이나 철야작업으로 인해 노동자가 항상 대기 상황에 처하지 않도록 예측 가능한 교대작업의 정보를 제공하고 있는가?",
                  is_checked: "",
                },
                {
                  id: 5,
                  type: "마",
                  label: "야간작업으로 인한 사고 발생 확률 저감을 위하여 교대작업일수, 업무 내용 등을 탄력적으로 조정하고 있는가?",
                  is_checked: "",
                },
              ],
            },
            {
              headerTitle: "건강문제 요인",
              headerYesTitle: "작성",
              headerNoTitle: "미작성",
              isTypeMode: true,
              isInputMode: false,
              list: [
                {
                  id: 1,
                  type: "가",
                  label: "생체주기의 변화 및 일주기 리듬의 교란으로 인한 건강상의 문제에 대처하고 있는가?",
                  is_checked: "",
                },
                {
                  id: 2,
                  type: "나",
                  label: "누적된 피로로 인한 사고 발생 위험성 저감을 위해 대처하고 있는가?",
                  is_checked: "",
                },
                {
                  id: 3,
                  type: "다",
                  label: "정기적인 건강상태 확인이 유지되고 있는가?",
                  is_checked: "",
                },
                {
                  id: 4,
                  type: "라",
                  label: "야간작업에 대한 교육 및 훈련이 실행되고 있는가?",
                  is_checked: "",
                },
                {
                  id: 5,
                  type: "마",
                  label: "노동자 생활 습관 관리를 위한 재충전의 기회를 제공하고 있는가?",
                  is_checked: "",
                },
              ],
            },
          ],
        },
      ];
    },
  },
  data() {
    return {
      form: {
        stdInfo: {},
        inspectionList: [],
        adminList: [],
        typeTitleList: [],

        inputB_1: "",
        inputB_2: "",
        inputB_3: "",
        inputB_4: "",
        inputB_5: "",
        inputB_6: "",
        inputB_7: "",
        inputB_8: "",

        inputC_1: "",
        inputC_2: "",
        inputC_3: "",
        inputC_4: "",
        inputC_5: "",
        inputC_6: "",
        inputC_7: "",
        inputC_8: "",
        inputC_9: "",
        inputC_10: "",
        inputC_11: "",
        inputC_12: "",
        inputC_13: "",
        inputC_14: "",
        inputC_15: "",
        inputC_16: "",
        inputC_17: "",
        inputC_18: {}, // file

        sign1: {
          name: "",
          sign: "",
        },
        sign2: {
          name: "",
          sign: "",
        },

        fileList: [],
      },
    };
  },
};
</script>

<style scoped lang="scss">
$border: 1px solid #cdcdcd;
$w-inpu0: 260px;
$w-inpu1: 220px;
$w-inpu2: 140px;
.center-flex {
  display: flex;
  justify-content: center;
  align-items: center;
}

.bg-1 {
  background-color: #f9f9f9;
  border-bottom: $border;
}

.label-text {
  width: 110px;
  font-weight: 500;
  font-size: 14px;
  padding-right: 12px;
}

.mt-component-form {
  margin-top: 15px;
}

.text-box {
  line-height: 19px;
  margin-top: 15px;
  border: $border;
}

/* uploaded File */
.form-group {
  border: $border;
  overflow: auto;
  width: 100%;
  /*overflow-x: auto;*/

  &__header {
    height: 80px;
    width: 100%;
    display: flex;

    &-title {
      min-width: $w-inpu2;
      border-left: $border;
      border-bottom: $border;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    &-title.title-checked {
      margin: 0;
      min-width: 40px;
      max-width: 40px;
      border-left: none;
      padding-left: 10px;
    }
  }

  &__content {
    width: 100%;
    display: flex;

    &-row {
      min-width: $w-inpu2;
      border-left: $border;
      border-bottom: $border;
      padding: 7px;
    }

    &-row.row-checked {
      margin: 0;
      min-width: 40px;
      max-width: 40px;
      border-left: none;
      padding-left: 10px;
    }

    &-row.row-w2 {
      min-width: $w-inpu1;
    }
  }
}

.row-w1 {
  min-width: $w-inpu1;
}

.row-w0 {
  min-width: $w-inpu0;
}

.bx {
  border-left: $border;
  border-right: $border;
}

.br {
  border-right: $border;
}

.bb {
  border-bottom: $border;
}
</style>
